export const SERVER_AJAX_URL = 'https://www.cedarworks.com';

export const IMAGECACHE_URL = 'https://www.cedarworks.com/imagecache';

export const IMAGEPROXY_URL = 'https://gateway.cedarworks.com/imageproxy/';

export const LIBRARY_3D_URL = 'https://3d.cedarworks.com/website/viewer/library/';

export const DESIGN_TOOL_ENDPOINT = 'https://builder.cedarworks.com/app/';

export const MISSING_IMAGE_RECTANGLE = 'https://www.cedarworks.com/imagecache/design-elements/800/a/a/image_not_found_rectangle_10112021.gif';

